import 'UI/Module'
import 'Glonass/UI/Header'
import 'Glonass/UI/Footer'
import 'Glonass/UI/Workspace'

/** @namespace Glonass.UI */
NS('Glonass.UI')

/**
 * @class
 * @extends UI.UI
 */
Glonass.UI.UI = Class(UI.UI, /** @lends Glonass.UI.UI.prototype */{
    notificationContainerTemplate: 'Glonass/Notification/Container',
    notificationItemTemplate: 'Glonass/Notification/Item',
    layoutElement: 'layout',
    header: null,
    telephony: null,
    workspace: null,
    footer: null,

    headerClass: 'Glonass.UI.Header',
    telephonyClass: null,
    footerClass: 'Glonass.UI.Footer',
    workspaceClass: 'Glonass.UI.Workspace',

    $notificationContainer: null,

    init (callback) {
        UI.Template.renderer = UI.Renderer.EJS
        UI.Template.renderer.init()

        this.header = this.createWidget(this.headerClass)
        this.telephony = this.createWidget(this.telephonyClass)
        this.footer = this.createWidget(this.footerClass)
        this.workspace = this.createWidget(this.workspaceClass)

        if (Util.isFunction(callback)) {
            callback.call(this)
        }

        return this
    },

    run (callback) {
        let self = this,
            layout = document.getElementById('layout') || document.body

        function render (object) {
            if (object) {
                object.render().appendTo(layout)
            }
        }

        render(this.header)
        render(this.telephony)
        render(this.footer)
        render(this.workspace)

        if (this.header) {
            this.header.on('homeClick', function () {
                if (self.workspace) {
                    self.workspace.showMenu()
                }
            })
        }

        if (Util.isFunction(callback)) {
            callback.call(this)
        }
    },

    createWidget (className, args) {
        args = Util.coalesce(args, [])

        if (!Util.isArray(args)) {
            args = [args]
        }

        args.unshift(this)

        if (className) {
            return Util.create(className, args)
        }

        return null
    },

    notify (message, timeout) {
        const self = this

        timeout = Util.coalesce(timeout, 3000)

        if (!this.$notificationContainer) {
            this.$notificationContainer = UI.Template.$render(this.notificationContainerTemplate).appendTo('body')
        }

        const $item = UI.Template.$render(this.notificationItemTemplate, { message: message }).appendTo(
            this.$notificationContainer)

        setTimeout(function () {
            $item.remove()

            if (!self.$notificationContainer.children().length) {
                self.$notificationContainer.remove()
                self.$notificationContainer = null
            }
        }, timeout)
    },

    play (name) {
        document.getElementById(name).play()
    },

    pause (name) {
        document.getElementById(name).pause()
    },

    spinnerStart () {},
    spinnerStop () {},
})
